"use strict";

var React = require("react"),
    Icon = require("./Icon.js"),
    WarningIcon = function WarningIcon(e) {
  return React.createElement(Icon, e, React.createElement("path", {
    d: "M9 5v2.286L9.5 13h1l.5-5.714V5z"
  }), React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  }));
};

module.exports = WarningIcon;